import { IonIcon } from '@ionic/react';
import clsx from 'clsx';
import React, { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';

type Props = {
  theme: 'blue' | 'green' | 'lavender';
  header: string;
  subtitle: string;
  icon: string;
  to?: string;
  href?: string;
  linkLabel?: string;
} & PropsWithChildren;

export default function ContactInfoCard({
  theme = 'blue',
  to,
  icon,
  header,
  subtitle,
  linkLabel,
  children,
  href,
}: Props) {
  const wrapperStyle = clsx(
    'p-6 flex flex-col whitespace-pre-line gap-4 rounded-lg border border-border medium-emphasis-text',
    theme === 'blue' && 'bg-customs-blue-foreground',
    theme === 'lavender' && 'bg-customs-lavender-foreground',
    theme === 'green' && 'bg-customs-green-foreground'
  );
  const iconWrapper = clsx(
    'p-2 rounded-md border text-white w-6 h-6 box-content',
    theme === 'blue' && 'bg-customs-blue border-customs-blue',
    theme === 'lavender' && 'bg-customs-lavender border-customs-lavender',
    theme === 'green' && 'bg-customs-green border-customs-green'
  );

  return (
    <div className={wrapperStyle}>
      <div className="flex-1 space-y-6">
        <div className={iconWrapper}>
          <IonIcon icon={icon} className="size-6" />
        </div>

        <div className="space-y-2">
          <h5 className="font-semibold high-emphasis-text">{header}</h5>
          <p>{subtitle}</p>
        </div>

        {children}
      </div>

      {to && (
        <Link
          to={to}
          className={`block px-4 py-2 rounded-md border border-border text-white font-medium w-fit ${iconWrapper}`}
        >
          {linkLabel || to}
        </Link>
      )}

      {href && (
        <a
          href={href}
          target="_blank"
          className={`block px-4 py-2 rounded-md border border-border text-white font-medium w-fit ${iconWrapper}`}
        >
          {linkLabel || href}
        </a>
      )}
    </div>
  );
}
